export enum WorkflowVersionActionType {
  Deploy = 1,
  Undeploy = 2,
  Remove = 3,
}
